module.exports = __webpack_public_path__ + "623e3205570002af47fc2b88f9335d19.woff";